import http from './http';

class PaymentService {
    getPayments() {
        return http.get('/user/payments');
    }

    getPaymentsAdmin(params) {
        return http.get('/user/payments/admin', { params });
    }

    getPayment(paymentId) {
        return http.get(`/user/payments/${paymentId}/status`);
    }

    getTxidStatus(txid) {
        return http.get(`/user/payments/status-by-txid/${txid}`);
    }

    createPayment(paymentId) {
        return http.post(`/user/payments/${paymentId}`);
    }
    confirmManualPayment(paymentId) {
        return http.post(`/user/payments/admin/${paymentId}/confirm`);
    }
}

export default new PaymentService(); 
